import { StepNavigation } from './StepNavigation';

import type { EvaluationStep, StepDefinition } from '../../Evaluation/types';

interface StepHeaderProps {
    currentStep: EvaluationStep;
    employeeFirstName?: string;
    onStepClick: (step: StepDefinition) => void;
}

/* The ribbon has to meet the host's fixed header exactly, and that height is the host's to decide:
   it publishes it, the ribbon reads it. Writing the number here instead meant writing the desktop
   one, and the header is shorter below the host's own breakpoint — which left the page showing
   through the gap at every width under it. With nothing publishing a height there is no header to
   clear, hence the zero. The expression is repeated below rather than held in a constant: Tailwind
   only generates a class it can see spelled out. */
export const StepHeader = (props: StepHeaderProps) => (
    <div
        className={
            'assessment-journey sticky top-[var(--amelio-header-height,0px)] z-50 max-md:py-[8px] md:py-[12px]'
        }
    >
        {/* The band spans the module while its steps stay in the journey's column. To the left it
            overshoots by a whole window, which needs nothing from the host and can never be
            scrolled to. To the right it stops at the module's edge: the column is centred in
            `.app-container` (`100cqw`), and an overshoot there would widen the page. */}
        {/* The same glass as the host's top bar, which this band continues: half-opaque white
            over the large glass blur. The blur reads the shared token; the host writes its own
            half-opaque white in SCSS and publishes no custom property for it, so that one value
            lives on both sides of the boundary and moves on both sides or not at all.

            Upwards, the layer runs a header's height behind the header itself, as it runs a window
            past the left edge: the host's hairline border sits below its glass and
            above ours, and a layer that stopped at our own top edge would leave that hairline
            backed by nothing but the page. The header paints over the overshoot, so it costs
            nothing and cannot fall short. */}
        <div
            className={
                'backdrop-blur-glass-lg absolute top-[calc(var(--amelio-header-height,0px)*-1)] right-[calc((100%-100cqw)/2)] bottom-0 -left-[100vw] border-b border-white/20 bg-white/50 shadow-md'
            }
        />

        <div className={'relative'}>
            <StepNavigation {...props} />
        </div>
    </div>
);
